import { render, staticRenderFns } from "./companyIntroduction.vue?vue&type=template&id=b82a6f40&scoped=true"
import script from "./companyIntroduction.vue?vue&type=script&lang=js"
export * from "./companyIntroduction.vue?vue&type=script&lang=js"
import style0 from "./companyIntroduction.vue?vue&type=style&index=0&id=b82a6f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82a6f40",
  null
  
)

export default component.exports